<template>
  <div>
    <div class="air__utils__heading">
      <h5>Overzicht</h5>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-6">
        <div class="card">
          <div class="card-body">
            <reservations-date />
          </div>
        </div>

      </div>
      <div class="col-xl-4 col-lg-6">

      </div>
    </div>
  </div>
</template>
<script>
import ReservationsDate from '@/components/widgets/Reservations/ReservationsDate'
// import moment from 'moment'
export default {
  components: {
    ReservationsDate,
  },
}
</script>
